import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { Control } from '../../../../vas/business-objects/control/control.model';

export const controlFormUpdateControlTypeReducer = (
    state = initialState,
    action: actions.ControlFormUpdateControlType
): State => {
    return {
        ...state,
        controlForm: {
            ...state.controlForm,
            control: new Control({
                ...state.controlForm.control,
                controlType: action.payload.controlType.id
            })
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-form-update-control-type.reducer.ts